/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Condition } from './condition';
import { InsurancePeriod } from './insurancePeriod';
import { PaymentContributor } from './paymentContributor';
import { Price } from './price';
import { PrivateLiabilityInsurance } from './privateLiabilityInsurance';
import { PaymentFrequency } from './paymentFrequency';
import { PrivateLiabilityPackage } from './privateLiabilityPackage';
import { PaymentMethod } from './paymentMethod';
import { PrivateLiabilityTariff } from './privateLiabilityTariff';

/**
 * Represents a general liability insurance.   (german: Haftpflicht Versicherung)
 */
export interface PrivateLiabilityProduct {
  /**
   * Technical discriminator for the concrete product type.
   */
  productType: string;
  paymentMethod?: PaymentMethod;
  paymentFrequency?: PaymentFrequency;
  paymentContributor?: PaymentContributor;
  insurancePeriod?: InsurancePeriod;
  /**
   * Price affecting conditions, e.g. an incentive code.   (bipro-produktmodell::Kondition)
   */
  conditions?: Array<Condition>;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
  tariff: PrivateLiabilityTariff;
  package?: PrivateLiabilityPackage;
  /**
   * Elementary products. Lowest level in product hierarchy.  Smallest unit for price calculation, e.g. \"PHV\", \"PLUS\"   (bipro-produktmodell::Elementarprodukt)
   */
  elementaryProducts: Array<PrivateLiabilityInsurance>;
}
export namespace PrivateLiabilityProduct {}
